import { TTagFormValues } from './TagForm.types';

export const TAG_FORM_DEFAULT_VALUES: TTagFormValues = {
  name: '',
  color: '#000000',
};
